import React from 'react';

import IconButton from '../ui-components/IconButton';
import { translateNumber } from 'flow/utils/browser-utils';
import useLongPress from 'flow/hooks/useLongPress';

const keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'];
const letters = [
    ' ', // non-breaking space
    'A B C',
    'D E F',
    'G H I',
    'J K L',
    'M N O',
    'P Q R S',
    'T U V',
    'W X Y Z',
    null,
    '+',
    null,
];

interface KeypadProps {
    onClick: (query: string, isSearching?: boolean) => void;
    value: string;
}

const Keypad = ({ onClick, value }: KeypadProps) => {
    const queryVal = value || '';
    const onLongPress = useLongPress(
        () => {
            onClick(queryVal + '+');
        },
        {
            onStart: () => {
                onClick(queryVal + '0');
            },
        },
    );

    return (
        <div className="grid grid-cols-[repeat(3,3rem)] justify-center gap-3">
            {keys.map((item, index) => {
                const isZero = item === '0';

                return (
                    <IconButton
                        key={item}
                        dataTestId={`keypad-${item}`}
                        className="size-12 flex-col rounded-xl bg-gray-200"
                        {...(isZero ? onLongPress : {})}
                        onClick={
                            isZero ? undefined : () => onClick(queryVal + item)
                        }
                    >
                        <>
                            <div className="text-sm/3">
                                {translateNumber(item)}
                            </div>
                            <div className="text-[0.6rem] leading-4 text-gray-500">
                                {letters[index]}
                            </div>
                        </>
                    </IconButton>
                );
            })}
        </div>
    );
};

export default Keypad;
